// extracted by mini-css-extract-plugin
export default {"username":"styles_username__eBOFi","small":"styles_small__5caJy"};